var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.offer.settings.offerLink ? "a" : "div",
    {
      tag: "component",
      staticClass: "offer",
      attrs: { href: _vm.offer.settings.offerLink }
    },
    [
      _c("div", { staticClass: "offer__image", style: _vm.backgroundImage }),
      _c(
        "div",
        { staticClass: "offer__content" },
        [
          _c(
            "p",
            {
              staticClass: "offer__content-item offer__content-item--link-text"
            },
            [_vm._v(_vm._s(_vm.offer.settings.offerText))]
          ),
          _vm.offer.settings.offerLink
            ? _c(
                "v-link",
                {
                  staticClass: "offer__content-item offer__content-item--link",
                  attrs: { primary: true, href: _vm.offer.settings.offerLink }
                },
                [_vm._v(_vm._s(_vm.offer.settings.offerLinkText))]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }